import { render, staticRenderFns } from "./LectionsSwitcher.vue?vue&type=template&id=49f3a089&scoped=true"
import script from "./LectionsSwitcher.vue?vue&type=script&lang=js"
export * from "./LectionsSwitcher.vue?vue&type=script&lang=js"
import style0 from "./LectionsSwitcher.vue?vue&type=style&index=0&id=49f3a089&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f3a089",
  null
  
)

export default component.exports